export const PATH_INDEX = '/';
export const MAIN_INDEX = '/';

export const LINK_PATH_HOME = 'https://bishares.finance/';
export const LINK_PATH_ABOUT = 'https://bishares.finance/about-us';